import React from 'react';
import styles from './HandlerRegistry.module.scss';
import { HandlerRegistryCategoryOption } from './types';

interface HandlerRegistryTabsProps {
    categories: HandlerRegistryCategoryOption[];
    selectedCategory: string;
    onCategoryChange: (category: string) => void;
}

const HandlerRegistryTabs: React.FC<HandlerRegistryTabsProps> = ({ categories, selectedCategory, onCategoryChange }) => (
    <div className={styles.tabStrip} role="tablist">
        {categories.map((category) => (
            <button
                key={category.value}
                type="button"
                role="tab"
                aria-selected={category.value === selectedCategory}
                className={category.value === selectedCategory ? styles.tabActive : styles.tab}
                onClick={() => onCategoryChange(category.value)}
            >
                {category.label}
            </button>
        ))}
    </div>
);

export default HandlerRegistryTabs;
